import { createSelector } from '@reduxjs/toolkit';
import { selectDevices } from 'reduxStore/devices/selectors';

//📌 Selector for get all assetGroups from current profile.
export const selectAssetGroups = createSelector(
	[(state) => state.AssetGroups.data, (state) => state.Auth.selectedProfile.orgID],
	(assetGroupsData, orgID) => assetGroupsData[orgID] || []
);

//📌 Selector for get assetGroup by assetGroupID.
export const selectAssetGroupsByAssetGroupID = createSelector(
	[(state) => state.AssetGroups.data, (state) => state.Auth.selectedProfile.orgID, (_, groupID) => groupID],
	(assetGroupsData, orgID, groupID) =>
		(assetGroupsData[orgID] || []).find((assetGroup) => assetGroup.groupID === groupID) || null
);

//📌 Selector for get all assetGroups by siteID.
export const selectAssetGroupsBySiteID = createSelector(
	[(state) => state.AssetGroups.data, (state) => state.Auth.selectedProfile.orgID, (_, siteID) => siteID],
	(assetGroupsData, orgID, siteID) =>
		(assetGroupsData[orgID] || []).filter((assetGroup) => assetGroup.siteID === siteID) || []
);

// 📌 Selector for getting all devices from a specific groupID.
export const selectDevicesByGroupID = createSelector(
	[selectAssetGroups, selectDevices, (_state, groupID) => groupID],
	(assetGroupsData, allDevices, groupID) => {
		const groupDevices = assetGroupsData?.find((group) => group.groupID === groupID)?.devices;

		if (!Array.isArray(groupDevices)) return [];

		const groupDeviceSet = new Set(groupDevices);
		return allDevices.filter((device) => groupDeviceSet.has(device.deviceID));
	}
);

// Selector for get all groups by deviceID
export const selectAssetGroupsByDeviceID = createSelector(
	[selectAssetGroups, (_state, deviceID) => deviceID],
	(assetGroupsData, deviceID) => {
		return assetGroupsData.filter((group) => group.devices.includes(deviceID));
	}
);
